var exports = {
  "kL": "PushSettings.module__container___ZFFhYU",
  "Qq": "PushSettings.module__text___ZFFhYU",
  "DD": "PushSettings.module__title___ZFFhYU",
  "h_": "PushSettings.module__description___ZFFhYU",
  "GL": "PushSettings.module__comboboxWrap___ZFFhYU",
  "EA": "PushSettings.module__combobox___ZFFhYU",
};

module.exports = exports;
